import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13 5.865c-.6 0-1 .391-1 .978v9.776c0 .586.4.977 1 .977s1-.39 1-.977V6.843c0-.587-.4-.978-1-.978M7 0c-.6 0-1 .39-1 .977v15.642c0 .586.4.977 1 .977s1-.39 1-.977V.977C8 .391 7.6 0 7 0M1 9.776c-.6 0-1 .39-1 .977v5.866c0 .586.4.977 1 .977s1-.39 1-.977v-5.866c0-.586-.4-.977-1-.977"
    }, null, -1)
  ]))]))
}
export default { render: render }